<fm-header></fm-header>
<fm-dashboard-ui
    [navigationList]="navigationList$ | async"
    (navigationClickEventEmitter)="navigationClick($event)"></fm-dashboard-ui>
